import '@/styles/app.scss'
import * as Sentry from '@sentry/vue'
import { DefaultApolloClient } from '@vue/apollo-composable'
import { createPinia } from 'pinia'
import { createApp, h, provide } from 'vue'

import apolloClient, { setUnauthorizedHandler } from '@/apollo'
import App from '@/App.vue'
import i18n from '@/i18n/index.ts'
import router from '@/router'
import { useAuthStore } from '@/store/auth'

const pinia = createPinia()

const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient)
  },
  render: () => h(App),
})
  .use(i18n)
  .use(pinia)
  .use(router)

const authStore = useAuthStore(pinia)

setUnauthorizedHandler(() => {
  authStore.logout()
})

const sentry_dsn = import.meta.env.VITE_APP_SENTRY_DSN
if (sentry_dsn) {
  pinia.use(Sentry.createSentryPiniaPlugin())

  Sentry.init({
    app,
    dsn: sentry_dsn,
  })
}

app.mount('#app')
